import React from 'react';

export const CollapseUpper = ({
  className,
  color,
  height,
}: {
  className?: string;
  color?: string;
  height?: string;
}) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.19167 10.1668L0.375 9.35016L3 6.72516L5.625 9.35016L4.80833 10.1668L3 8.3585L1.19167 10.1668ZM3 4.27516L0.375 1.65016L1.19167 0.833496L3 2.64183L4.80833 0.833496L5.625 1.65016L3 4.27516Z"
      fill="#7D7A9A"
    />
  </svg>
);
